import PropTypes from "prop-types";

export const ImageSourcesType = PropTypes.shape({
  "regular@1x": PropTypes.string,
  "regular@2x": PropTypes.string,
  "regular@3x": PropTypes.string,
});
